import { useQuery } from '@tanstack/react-query'
import { getJobTitles } from '@/apis/freelancers'
import { useTeamScopeApiReady } from '@/hooks/useApiReady'

export const jobTitlesKeys = {
  all: ['job-titles'] as const,
  list: () => [...jobTitlesKeys.all, 'list'] as const,
}

/**
 * Hook React Query pour récupérer les job titles (métiers) de l'équipe.
 * Session-scoped — une seule clé partagée entre Missions / Freelancers / combobox.
 */
export function useJobTitles(options?: { enabled?: boolean }) {
  const apiReady = useTeamScopeApiReady()

  return useQuery({
    queryKey: jobTitlesKeys.list(),
    queryFn: async () => {
      const res = await getJobTitles()
      if (res.data?.code === 200) {
        return res.data.data?.job_titles || []
      }
      return []
    },
    enabled: apiReady && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  })
}
